import { AutospinInterface } from '../interface/autospinInterface/autospinInterface.class'
import { Button }            from './button.class'
import { Click }             from '../click/click.class'
import { disabled }          from './button.class.scss'
import { StateClick }        from '../stateClick/stateClick.class'
import { arch, hidden }      from '../../sass/button/arch/button.arch.class.scss'
import { AUTOSPIN_STATE }    from '../../constants/spinState/autospin-state.constant'
import { AUTOSPIN_VALUES }   from '../../constants/autospin-values/autospin-values.constant'
import { DISABLE_AUTOPLAY }  from '../../constants/disableAutoplay/disable-autoplay.constant'

/**
 * @file Defines the {@link AutospinButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

 /** 
  * Class for handling autospin button
  * @extends Button
  */
 export class AutospinButton extends Button {

    /**
     * Reference to autospin interface
     * @memberof AutospinButton
     * @protected
     * @instance
     * @type {AutospinInterface}
     */
    _interface

    /**
     * Initialise autospin button properties
     * @param {string[]} assets_          - Array of data URIs containing button assets.
     * @param {string}   id_              - ID of button.
     * @param {string[]} states_          - Array of possible button states.
     * @param {string[]} visible_         - Whether button is initially visible.
     * @param {function} text_            - Whether button has text.
     * @param {state-click-events} click_ - Object containg click events for each state.
     */
    constructor(assets_, id_, states_, visible_, text_ = null, click_) {

        //Call parent class constructor
        super(assets_, id_, states_, visible_, text_)

        //If autoplay disabled
        if (!getCanAutoplay_()) {

            this.elem.classList.add('hidden')                               //Hide button
            framework.isTouch() && this.textElem.classList.add('hidden')    //Hide button text

        }

        //If mobile
        if (framework.isTouch()) {

            this._interface =  new AutospinInterface()    //Create autospin interface
            new Click(this._elem, this.click, this)       //Add click handler
            new StateClick(this._elem, id_, click_, this) //Create state based click handlers

        }

        //Desktop
        else {

            new StateClick(this._elem, id_, click_, this) //Create state based click handlers
            this.state = 'START'                              //Set default state

            //If button has text
            if (text_) {

                //Loop through buttons children nodes
                for (let i = 0; i < this._elem.children.length; i++) {

                    let c = this._elem.children[i] //Store child node

                    //If text node found
                    if (c.id === 'auto_amount') {
                        this._textElem = c //Store reference to button text element
                    }

                }

            }

            //On autospin
            AUTOSPIN_STATE.onSpin.add(v_ => {

                //If not spinning
                if (!v_) {
                    document.getElementById('auto_amount').innerHTML = AUTOSPIN_VALUES.value() //Clear autoplay amount
                }
                
            })

        }

    }

    /** Get interface */ get interface() { return this._interface }

    /**
     * Click handler for autospin
     * @param {object} this_ - Reference to class's scope
     */
    click(this_) {

        let _this = this_ //Store reference to scope
        
        //If user clicked stop
        if (_this.state === 'STOP') {
            this_.enable = false //Disable autospin button
        }

        //START state
        if (_this.state === 'START' && buttonManager_.getCurrentState() === 'NH') {

            _this.interface.show = true                         //Show autospin interface
            document.getElementById(arch).classList.add(hidden) //Hide portrait arch

        }

        _this.interface.render() //Render autospin interface

    }

 }